/**
 * @deprecated
 */
var fg = require('./base');

/**
 * @fileoverview Generator for unique IDs.
 *
 */

/**
 * Creates a new id generator.
 * @constructor
 * @final
 */
var IdGenerator = function() {
};
fg.addSingletonGetter(IdGenerator);


/**
 * Next unique ID to use
 * @type {number}
 * @private
 */
IdGenerator.prototype.nextId_ = 0;


/**
 * Gets the next unique ID.
 * @return {string} The next unique identifier.
 */
IdGenerator.prototype.getNextUniqueId = function() {
    return 'id' + (this.nextId_++).toString(36);
};

module.exports = IdGenerator;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/idGenerator.js